import VideosListOnDemandScreen from './VideosListOnDemand';

export default VideosListOnDemandScreen;
